/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teams_Add_Member_Dialog_DescriptionInputs */



/**
* | output |
* | --- |
* | "Select a user from your organization to add to this team." |
*
* @param {Teams_Add_Member_Dialog_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teams_add_member_dialog_description = /** @type {((inputs?: Teams_Add_Member_Dialog_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_Add_Member_Dialog_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie einen Benutzer aus Ihrer Organisation aus, um ihn zu diesem Team hinzuzufügen.")
	return /** @type {LocalizedString} */ ("Select a user from your organization to add to this team.")
});